const MARKUP_CONTENT_TYPE = /\b(?:html|xml)\b/i

/*
 * Named so a misfire is attributable at a glance: this guard sits on every HTTP call, so an
 * unexpected throw would otherwise surface in Sentry as an ordinary failure of whatever feature
 * happened to make the request. Sentry titles an event by `name`.
 */
export class NonDataResponseError extends Error {
  override readonly name = 'NonDataResponseError'

  // Deliberately not `status`: the response succeeded, and both the rxjs and axios error conventions
  // use `status` for a *failing* HTTP status, which duck-typed handlers key off.
  constructor(
    readonly url: string | undefined,
    readonly httpStatus: number,
    readonly contentType: string
  ) {
    super(`Expected a data body from ${url}, got ${contentType} (${httpStatus})`)
  }
}

/*
 * Markup only, not "anything but JSON": bodyless 2xx and bare-text payloads are both legitimate on
 * these clients. Header-only, because axios hands the caller unparsed HTML as `data` and rxjs hands it
 * null, so neither body shape identifies the case on its own.
 */
export const assertNotMarkup = (url: string | undefined, status: number, contentType: unknown) => {
  if (typeof contentType === 'string' && MARKUP_CONTENT_TYPE.test(contentType)) {
    throw new NonDataResponseError(url, status, contentType)
  }
}
